export default __webpack_public_path__ + "static/media/back.44e8b9fd.svg";